import MapElement from "./MapElement";

export default class Annotation extends MapElement {

    constructor(id, hidden) {
        super(id, hidden);
    }

    // eslint-disable-next-line no-unused-vars
    getMapElementStyle(urlToAsset) {
        throw new Error("Method must be overriden by subclasses.");
    }
}